import url_acc from '@/urls/accounts'
import { sendDeleteRequest, sendGetRequest } from '@/helper/requests'

const state = {
  session: []
}

const getters = {
  getSession: state => state.session,
}

const mutations = {
  SET_SESSION_LIST: (state, value) => {
    /**
     * Устанавливает список сессий пользователя
     * @param {Object} state - состояние хранилища
     * @param {Array} value - список сессий
     */
    state.session = value
  },
}

const actions = {
  loadUserSession: ({ commit }, { url, finalizer, catcher }) => {
    /**
     * Загружает сессии пользователя
     * @param {Object} commit - контекст Vuex
     * @param {string} params.url - URL для загрузки (опционально)
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    if (!url) url = url_acc.PROFILE.SESSION.LIST()
    sendGetRequest(
      url, (data, url) => {
        commit('SET_SESSION_LIST', data)
        finalizer(data, url)
      }, catcher
    )
  },
  deleteUserSession: ({ commit }, { key, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Удаляет сессию пользователя
     * @param {Object} commit - контекст Vuex
     * @param {string} key - ключ сессии
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = url_acc.PROFILE.SESSION.DELETE(key)
    sendDeleteRequest(
      url, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  },
  deleteUserAllSession: ({ commit }, { finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Удаляет все сессии пользователя
     * @param {Object} commit - контекст Vuex
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = url_acc.PROFILE.SESSION.DELETE_ALL()
    sendDeleteRequest(
      url, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  },
}
export default {
  state,
  mutations,
  getters,
  actions
}
